import request from '@/utils/request'

export const getUnitconfigList = ({ page, size, keywords: unitName }) => {
  return request({
    url: `/trace/unit/${page}/${size}`,
    params: {
      unitName
    }
  })
}

export const putUnitconfigAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/unit',
    data
  })
}

export const postUnitconfigEdit = (data) => {
  return request({
    method: 'post',
    url: 'trace/unit',
    data
  })
}

export const getUnitconfigDetail = (id) => {
  return request({
    url: `/trace/unit/${id}`
  })
}

export const deleteUnitconfigDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/unit/${id}`
  })
}

export const getUnitTypeList = () => {
  return request({
    url: '/upms/dict/data/option/unit'
  })
}

export const delUnitList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/unit/all',
    data
  })
}
